/** @format */
import React from 'react';
import { IconButton, Typography, CircularProgress } from '@mui/material';
import { FilterTextField, FilterSelective, TableItemActionsNew, Icons } from 'components';
import { numberWithCommas } from 'utility';
import { getTotalMyServiceCall } from '../../serviecs';
import useCustomHook from '../../hooks';

const status = [
  {
    label: 'همه',
    value: 'all',
  },
  // {
  //   label: 'رد شده',
  //   value: 'رد شده'
  // },
  {
    label: 'تایید شده',
    value: 'تایید شده',
  },
  {
    label: 'درخواست داده شده',
    value: 'درخواست داده شده',
  },
  {
    label: 'لغو پس از تایید توسط سرویس دهنده',
    value: 'لغو پس از تایید توسط سرویس دهنده',
  },
  {
    label: 'لغو شده توسط سرویس گیرنده',
    value: 'لغو شده توسط سرویس گیرنده',
  },
  {
    label: 'لغو شده توسط سرویس دهنده',
    value: 'لغو شده توسط سرویس دهنده',
  },
];

const columns = (confirmRequest, revokeRequest) => [
  {
    title: 'ردیف',
    field: 'num',
    filtering: false,
    align: 'center',
    cellStyle: {
      width: '1%',
    },
    headerStyle: {
      width: '1%',
    },
  },
  {
    title: 'شناسه سرویس',
    field: 'serviceId',
    align: 'center',
    filterComponent: (props) => <FilterTextField size="small" {...props} />,
  },
  {
    title: 'نام سرویس',
    field: 'serviceName',
    filterComponent: (props) => <FilterTextField size="small" {...props} />,
  },
  {
    title: 'تاریخ درخواست',
    field: 'dateTime',
    filtering: false,
    // filterComponent: (props) => <FilterDateTime size="small" {...props} />
  },
  {
    title: 'وضعیت',
    field: 'status',
    // filtering: false
    filterComponent: (props) => <FilterSelective options={status} size="small" {...props} />,
  },
  {
    title: 'client_id',
    field: 'clientId',
    filtering: false,
    render: (rowData) => <span style={{ fontFamily: 'Vazir' }}>{rowData?.clientId}</span>,
  },
  {
    title: 'تعداد کل فراخوانی ها',
    field: 'totalCall',
    filtering: false,
    sorting: false,
    align: 'center',
    render: (rowData) => <TotalReqs item={rowData} />,
  },
  {
    title: 'عملیات',
    field: '',
    filtering: false,
    sorting: false,
    align: 'center',
    render: (rowData) => (
      <TableItemActionsNew
        iconButton
        startIcon={<Icons icon="MoreHorizontal" color="#667585"  size="20" />}
        title=""
        otherMenus={[
          {
            icon: () => <Icons icon='Accept' color="#4CAF50" size="22" />,
            title: 'تایید درخواست',
            isShow: true,
            disabled: !(rowData.status === 'درخواست داده شده'),
            onClick: () => {
              confirmRequest(rowData);
            },
          },
          {
            icon: () => <Icons icon='CloseCircle' color="#F44336" size="22" />,
            title: 'رد درخواست',
            isShow: true,
            disabled: !(rowData.status === 'تایید شده'),
            onClick: () => {
              revokeRequest(rowData);
            },
          },
        ]}
      />
    ),
  },
];

const TotalReqs = ({ item }) => {
  // --STATES--//
  const { totalNum, setTotalNum, loading, setLoading } = useCustomHook();
  // --HOOKS--//

  // --API REQS--//
  const getTotals = async () => {
    if (!item?.serviceId || loading) return;
    setLoading(true);
    try {
      const res = await getTotalMyServiceCall(item.serviceId);
      setTotalNum(res?.result);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  return totalNum == null ? (
    <IconButton onClick={getTotals} size="large">
      {loading ? <CircularProgress color="inherit" size={23} /> : <Icons icon="eye" color="#667585"  size={23} />}
    </IconButton>
  ) : (
    <Typography
      style={{
        minHeight: 48,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {numberWithCommas(totalNum)}
    </Typography>
  );
};

const columnsId = {
  serviceName: '3002',
  receiverService: '1303',
  serviceId: '3004',
  status: '3005',
};

export { columns, columnsId };
